import React from 'react';
import { AppBar
, Toolbar
, Typography
, Grid
, Button
, Avatar} from '@material-ui/core';

import VerifiedUserRoundedIcon from '@material-ui/icons/VerifiedUserRounded';
import LockIcon from '@material-ui/icons/Lock';

import logo from '../assets/img/logo_4.png';
import { useSelector, useDispatch } from 'react-redux';
import State from '../states/State';

import { FiLogOut } from 'react-icons/fi';
import { useHistory } from "react-router-dom";
import slice from '../states/shell/slice';
import drawerSlice from '../states/drawer/slice';
import ReceiptIcon from '@material-ui/icons/Receipt';
import useStyles from '../styles/styles';
import useToken from '../hooks/UseToken';


type TopBarProps = {};

const PeTopBar: React.FC<TopBarProps> = props => {
  const classes = useStyles();
  const state = useSelector((state: State) => ({
    shell: state.shell,
  }));
  const { isAuth } = state.shell;

  const history = useHistory();
  const search = history.location.search;
  const dispatch = useDispatch();
  const { token, clearToken } = useToken();

  const handleLoginClick = () => {
    history.push("/login" + (search ? `?callback=/master${search}` : ""));
  }

  const handleLogoutClick = () => {
    clearToken();
    dispatch(slice.actions.updateIsAuth(false));
    history.push("/" + search);
  }
  const handleOpenDrawer = () => {
    dispatch(drawerSlice.actions.updateDrawer(true));
  };

  const isLayout = state.shell.layout;

  return (<div>
    {isLayout === 0 ? <div>
      <AppBar position="static" className={classes.PeTopBar_appbar}>
          <Toolbar>
            <Grid container spacing={2}>
              <Grid item xs>
              <img src={logo} alt="Logo" className={classes.PeTopBar_logo}/>
              </Grid>
              <Grid item xs={7} className={classes.title}>
                <Typography variant="h5" noWrap className={classes.titleText}>DAIKIN QUOTE FORM</Typography>
              </Grid>
              <Grid item xs className={classes.mode}>
                {isAuth ? <div style={{display: 'flex', alignItems: 'center'}}>
                  <Button variant="outlined"
                    size="small"
                  className={classes.PeTopBar_button}
                    style={{color: '#1976D2', borderColor: '#1976D2'}}
                    startIcon={<VerifiedUserRoundedIcon />}>
                      MASTER
                  </Button>
                  <Avatar style={{marginLeft: '10px'}}>{token ? token.user.first_name ? token.user.first_name.charAt(0) : 'A' : 'A'}</Avatar>
                  <p style={{padding: '0 10px'}}>Hello, {token ? token.user.first_name ? token.user.first_name : 'Admin' : 'Admin'}</p>
                  <h3 style={{margin: '3px 0 0 10px', cursor: 'pointer'}} onClick={handleLogoutClick}><FiLogOut /></h3>
                </div> : <Button variant="outlined"
                  size="small"
                  className={classes.PeTopBar_button}
                  style={{color: '#d21919', borderColor: '#d21919'}}
                  onClick={handleLoginClick}
                  startIcon={<LockIcon />}>
                    LOGIN
                  </Button>}
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
      : <AppBar position="static" className={classes.PeTopBar_appbar}>
      <Toolbar>
        <Grid container spacing={2} className={classes.centerItem}>
              <Grid item xs>
                <img src={logo} alt="Logo" className={classes.logoMobile}/>
              </Grid>
              <Grid item xs className={classes.rightItem}>
                <Button variant="outlined"
                    size="small"
                    className={classes.PeTopBar_button}
                    style={{color: '#1178AB', borderColor: '#1178AB', background: '#ffffff'}}
                    startIcon={<ReceiptIcon />} onClick={handleOpenDrawer}>
                        SUMMARY
                </Button>
                {/* <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleOpenDrawer}>
                  <DehazeOutlined />
                </IconButton> */}
              </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
    }
  </div>)
}

export default PeTopBar;